/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type DeleteExpenseItemInput = {
    id?: string | null | undefined;
    projectId?: string | null | undefined;
    companyProjectId?: number | null | undefined;
    companyId?: string | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type deleteExpenseItemMutationVariables = {
    input: DeleteExpenseItemInput;
};
export type deleteExpenseItemMutationResponse = {
    readonly deleteExpenseItem: {
        readonly deletedExpenseItemId: string | null;
    } | null;
};
export type deleteExpenseItemMutation = {
    readonly response: deleteExpenseItemMutationResponse;
    readonly variables: deleteExpenseItemMutationVariables;
};



/*
mutation deleteExpenseItemMutation(
  $input: DeleteExpenseItemInput!
) {
  deleteExpenseItem(input: $input) {
    deletedExpenseItemId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteExpenseItemInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteExpenseItemPayload",
    "kind": "LinkedField",
    "name": "deleteExpenseItem",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedExpenseItemId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteExpenseItemMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteExpenseItemMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "deleteExpenseItemMutation",
    "operationKind": "mutation",
    "text": "mutation deleteExpenseItemMutation(\n  $input: DeleteExpenseItemInput!\n) {\n  deleteExpenseItem(input: $input) {\n    deletedExpenseItemId\n  }\n}\n"
  }
};
})();
(node as any).hash = '53a9f5382ff7b4c64ab49bf27a2fc0ea';
export default node;
